export enum EUserStatus {
  PENDING = 'PENDING',
  VERIFIED = 'VERIFIED',
  BLOCKED = 'BLOCKED',
  DISABLED = 'DISABLED',
  UNVERIFIED = 'UNVERIFIED',
  REGISTERED = 'REGISTERED'
}
  